const pushInfo = {
  state: {
    tabList: [],
    tabsInfo: {},
    pushItemRow: {},
    pushItemId: ''
  },
  getters: {
    getTabList: (state) => state.tabList,
    openTabsInfo: (state) => state.tabsInfo,
    changePushItemRow: (state) => state.pushItemRow,
    delPushItemId: (state) => state.pushItemId,
  },
  mutations: {
    SETTABLIST(state, data) {
      state.tabList = data;
    },
    OPENTABS(state, row) {
      state.tabsInfo = {};
      state.tabsInfo = row;
    },
    CHANGEPUSHSTATUS(state, row) {
      state.pushItemRow = row;
    },
    DELPUSHITEMID(state, id) {
      state.pushItemId = id;
    }
  },
  actions: {
  }
}
export default pushInfo;


// WEBPACK FOOTER //
// ./src/managers/vuex/modules/push.js